import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitPlanModel } from '@apps-common/types/management/unit-plan'

export const MANAGEMENT_QUERY_KEY_SEARCH_UNIT_PLANS = (search?: string) => ['searchUnitPlans', search].filter(Boolean)

export const searchUnitPlans = async (search?: string): Promise<IUnitPlanModel[]> =>
  axios.get(`/management/unitplan/SearchUnitPlans?search=${search || ''}`).then((res) => res.data?.data)

type QueryFnType = typeof searchUnitPlans

type Props = {
  config?: QueryConfig<QueryFnType>
  search?: string
}

export const useManagementSearchUnitPlans = ({ config, search }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_SEARCH_UNIT_PLANS(search),
    queryFn: () => searchUnitPlans(search)
  })
